/* eslint-disable jsx-a11y/alt-text */
import React, { useRef } from "react";
import { IoPrintOutline } from "react-icons/io5";
import ReactToPrint from "react-to-print";
import { button } from "../../../../theme/lightTheme";

export const PrintNOCApplication = (props) => {
  const componentRef = useRef();

  return (
    <>
      {/* =========================
          SCREEN VIEW
      ========================== */}
      <div className="my-4">
        <ReactToPrint
          trigger={() => (
            <button
              type="button"
              className={`${button} inline-flex items-center justify-center`}
            >
              <span className="flex items-center gap-2">
                <IoPrintOutline size={18} />
                <span>Print / Download {props?.buttonName}</span>
              </span>
            </button>
          )}
          content={() => componentRef.current}
          documentTitle={props?.reportTitle || "NOC Application"}
          bodyClass="noc-print-body"
          // pageStyle={`
          //   @page {
          //     size: A4 portrait;
          //     margin: 0;
          //   }

          //   html,
          //   body {
          //     margin: 0 !important;
          //     padding: 0 !important;
          //     width: 210mm;
          //     background: #ffffff !important;
          //   }

          //   * {
          //     box-sizing: border-box;
          //   }

          //   .noc-print-sheet {
          //     width: 210mm;
          //     height: 297mm;
          //     padding: 8mm 10mm;
          //     background: #ffffff;
          //     overflow: hidden;
          //   }

          //   .noc-print-copy {
          //     width: 190mm;
          //     height: 140mm;
          //     overflow: hidden;
          //     background: #ffffff;
          //     page-break-inside: avoid;
          //     break-inside: avoid;
          //   }

          //   .noc-print-copy + .noc-print-copy {
          //     margin-top: 3mm;
          //   }

          //   .noc-print-copy .noc-content {
          //     font-size: 10pt !important;
          //     line-height: 1.35 !important;
          //   }

          //   .noc-print-copy .noc-header {
          //     margin-top: 0 !important;
          //     margin-bottom: 3mm !important;
          //   }

          //   .noc-print-copy .noc-logo {
          //     width: 14mm !important;
          //     height: 14mm !important;
          //   }

          //   .noc-print-copy .noc-title {
          //     font-size: 11pt !important;
          //     line-height: 1.2 !important;
          //   }

          //   .noc-print-copy .noc-address {
          //     font-size: 9pt !important;
          //     line-height: 1.2 !important;
          //   }

          //   .noc-print-copy .noc-qr {
          //     width: 24mm !important;
          //     height: 24mm !important;
          //   }

          //   .noc-print-copy .noc-meta {
          //     font-size: 9.5pt !important;
          //     margin-bottom: 2mm !important;
          //   }

          //   .noc-print-copy .noc-heading {
          //     font-size: 11pt !important;
          //     margin-bottom: 3mm !important;
          //   }

          //   .noc-print-copy .noc-paragraph {
          //     margin-top: 2mm !important;
          //     margin-bottom: 0 !important;
          //   }

          //   .noc-print-copy .noc-signature {
          //     margin-top: 5mm !important;
          //   }
          // `}

          pageStyle={`
                @page {
                  size: A4 portrait;
                  margin: 0;
                }

                html,
                body {
                  margin: 0 !important;
                  padding: 0 !important;
                  width: 210mm;
                  background: #ffffff !important;
                }

                * {
                  box-sizing: border-box;
                }

                .noc-print-sheet {
                  width: 210mm;
                  height: 297mm;
                  padding: 5mm 8mm;
                  background: #ffffff;
                  overflow: hidden;
                }

                .noc-print-copy {
                  width: 194mm;
                  height: 142mm;
                  overflow: hidden;
                  background: #ffffff;
                  page-break-inside: avoid;
                  break-inside: avoid;
                }

                .noc-print-copy + .noc-print-copy {
                  margin-top: 2mm;
                }

                /* Main content */
                .noc-print-copy .noc-content {
                  font-size: 8.5pt !important;
                  line-height: 1.25 !important;
                }

                /* Header */
                .noc-print-copy .noc-header {
                  margin-top: 0 !important;
                  margin-bottom: 1.5mm !important;
                }

                .noc-print-copy .noc-logo {
                  width: 11mm !important;
                  height: 11mm !important;
                }

                .noc-print-copy .noc-title {
                  font-size: 9.5pt !important;
                  line-height: 1.05 !important;
                }

                .noc-print-copy .noc-address {
                  font-size: 7.5pt !important;
                  line-height: 1.05 !important;
                }

                /* QR */
                .noc-print-copy .noc-qr {
                  width: 18mm !important;
                  height: 18mm !important;
                }

                /* Meta information */
                .noc-print-copy .noc-meta {
                  font-size: 8pt !important;
                  line-height: 1.1 !important;
                  margin-bottom: 1mm !important;
                }

                /* Section heading */
                .noc-print-copy .noc-heading {
                  font-size: 9.5pt !important;
                  line-height: 1.1 !important;
                  margin-top: 1mm !important;
                  margin-bottom: 1.5mm !important;
                }

                /* Paragraphs */
                .noc-print-copy .noc-paragraph {
                  font-size: 8.5pt !important;
                  line-height: 1.25 !important;
                  margin-top: 1mm !important;
                  margin-bottom: 0 !important;
                }

                /* Signature */
                .noc-print-copy .noc-signature {
                  margin-top: 2.5mm !important;
                  font-size: 8pt !important;
                  line-height: 1.1 !important;
                }

                /* Tables / lists if present */
                .noc-print-copy table {
                  font-size: 8pt !important;
                  line-height: 1.1 !important;
                  margin: 1mm 0 !important;
                }

                .noc-print-copy th,
                .noc-print-copy td {
                  padding: 0.8mm 1mm !important;
                }

                .noc-print-copy ul,
                .noc-print-copy ol {
                  margin-top: 1mm !important;
                  margin-bottom: 1mm !important;
                  padding-left: 4mm !important;
                }

                .noc-print-copy li {
                  margin-bottom: 0.5mm !important;
                  line-height: 1.2 !important;
                }
              `}
        />
      </div>

      {/* =========================
          PRINT CONTENT
          Hidden from normal screen
          ========================== */}
      <div className="hidden">
        <section ref={componentRef}>
          <div className="noc-print-sheet">
            {/* COPY 1 */}
            <div className="noc-print-copy">{props?.children}</div>

            {/* CUT LINE */}
            <div className="my-2 flex items-center gap-3">
              <div className="flex-1 border-t-2 border-dashed border-gray-400" />

              <span className="text-[9px] font-medium uppercase tracking-wider text-gray-500">
                ✂
              </span>

              <div className="flex-1 border-t-2 border-dashed border-gray-400" />
            </div>

            {/* COPY 2 */}
            <div className="noc-print-copy">{props?.children}</div>
          </div>
        </section>
      </div>
    </>
  );
};
